






























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ConfigUsuarioStore, { TAMANHO_MINIMO_BUSCA_PESSOA, TAMANHO_CPF, TipoBuscaPessoaAgendamento } from '@/components/Configuracoes/store/ConfigUsuarioStore'
import { DataTablePagination } from '@/types/interfaces/EmailMensagem'
import { maskCPFCNPJ, getUfs, onlyNumber } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import { SuporteFeedbackModalDataProps } from '@/components/modals/SuporteFeedbackModal.vue'

@Component
export default class ViewConfiguracaoPessoa extends Vue {
  $refs!: { formPessoa: any }

  edtPessoa: boolean = false
  showSuporteFeedbackModal: boolean = false
  suporteFeedbackModalData: SuporteFeedbackModalDataProps[] = []

  get editPessoa() { return this.edtPessoa }
  set editPessoa(value: boolean) { this.edtPessoa = value }

  @Watch('editPessoa')
  onChangeEditPessoa(value: boolean) {
    if (!value) {
      this.$refs.formPessoa.resetValidation()
      this.$refs.formPessoa.reset()
    }
  }

  pessoaId: string = ''

  loadPessoas: boolean = false

  /** Nada de buscar antes do usuário clicar em Pesquisar (FXCS-6701). */
  buscaRealizada: boolean = false

  get loadingPessoas() { return this.loadPessoas }
  set loadingPessoas(value: boolean) { this.loadPessoas = value }

  get getConfigUsuarioStore() { return getModule(ConfigUsuarioStore, this.$store) }

  get searchPessoa() { return this.getConfigUsuarioStore.searchPessoa }
  set searchPessoa(value: string) { this.getConfigUsuarioStore.setSearchPessoa(value) }

  get tipoBusca() { return this.getConfigUsuarioStore.tipoBuscaPessoaAgendamento }
  set tipoBusca(value: TipoBuscaPessoaAgendamento) { this.getConfigUsuarioStore.setTipoBuscaPessoaAgendamento(value) }

  get opcoesDeBusca() {
    return [
      { text: 'Nome', value: 'nome' },
      { text: 'E-mail', value: 'email' },
      { text: 'CPF', value: 'cpf' },
      { text: 'CRM', value: 'crm' },
      { text: 'HisId', value: 'hisId' },
    ]
  }

  /** Para CPF o tamanho vale sobre os dígitos, não sobre a máscara. */
  get termoDeBusca() {
    const termo = (this.searchPessoa || '').trim()
    return this.tipoBusca === 'cpf' ? termo.replace(/\D/g, '') : termo
  }

  /**
   * Espelha o validator do backend: CPF com os 11 dígitos, nome e e-mail com 3 caracteres.
   * CRM e HisId são buscados por igualdade, então basta ter valor.
   */
  get buscaHabilitada() {
    if (this.tipoBusca === 'cpf') return this.termoDeBusca.length === TAMANHO_CPF
    if (this.tipoBusca === 'nome' || this.tipoBusca === 'email') return this.termoDeBusca.length >= TAMANHO_MINIMO_BUSCA_PESSOA
    return this.termoDeBusca.length > 0
  }

  get rotuloDoCampo() {
    return (this.opcoesDeBusca.find(opcao => opcao.value === this.tipoBusca) || { text: 'Nome' }).text
  }

  get exemploDoCampo() {
    if (this.tipoBusca === 'email') return 'maria@hospital.com.br'
    if (this.tipoBusca === 'cpf') return '123.456.789-00'
    if (this.tipoBusca === 'crm') return '123456'
    if (this.tipoBusca === 'hisId') return '2815397'
    return 'silva'
  }

  get dicaDoCampo() {
    if (this.tipoBusca === 'email') return 'Com @ busca o e-mail exato. Sem @ busca qualquer parte — ex.: "hospital".'
    if (this.tipoBusca === 'cpf') return 'CPF completo, com ou sem pontuação.'
    if (this.tipoBusca === 'crm') return 'Número do conselho completo.'
    if (this.tipoBusca === 'hisId') return 'HisId completo.'
    return 'Busca por qualquer parte do nome.'
  }

  get mensagemGradeVazia() {
    return this.buscaRealizada
      ? 'Nenhuma pessoa encontrada para essa busca.'
      : `Escolha o campo, digite o valor (nome e e-mail com ao menos ${TAMANHO_MINIMO_BUSCA_PESSOA} caracteres) e clique em Pesquisar.`
  }

  /** Trocar de campo invalida o termo digitado para o campo anterior. */
  onTipoBuscaChange() {
    this.searchPessoa = ''
  }

  get pessoas() { return this.getConfigUsuarioStore.pessoasAgendamento }
  get getPessoaId() { return this.pessoaId }
  set setPessoaId(value: string) { this.pessoaId = value }

  get pagination() { return this.getConfigUsuarioStore.pagination }

  get configUsuariosTableHeader() {
    return [
      { text: 'Nome', class: 'table-headers', align: 'left', value: 'nome', sortable: false },
      { text: 'CPF', class: 'table-headers', align: 'left', value: 'cpf', sortable: false },
      { text: 'Email', class: 'table-headers', align: 'left', value: 'email', sortable: false },
      { text: 'Telefone', class: 'table-headers', align: 'left', value: 'telefone', sortable: false },
      { text: 'Documento', class: 'table-headers', align: 'left', value: 'conselhoTipo', sortable: false },
      { text: 'Tem Login', class: 'table-headers', align: 'left', value: 'temLogin', sortable: false },
      { text: 'Ações', class: 'table-headers', align: 'center', value: '', sortable: false },
    ]
  }

  get ufs() { return [...getUfs()] }

  maskCPFCNPJUtil(value: string) { return maskCPFCNPJ(value) }

  onlyNumberUtil(value: any) { return onlyNumber(value) }

  async updatePagination(pagination: DataTablePagination) {
    // O v-data-table emite update:pagination na montagem e de novo quando a store
    // devolve a página: só busca se o usuário já pesquisou e a página mudou de fato.
    if (!this.buscaRealizada) return
    const atual = this.pagination
    if (pagination.page === atual.page && pagination.rowsPerPage === atual.rowsPerPage) return
    await this.buscarPagina(pagination)
  }

  async makeSearch() {
    if (!this.buscaHabilitada) return

    this.buscaRealizada = true
    await this.buscarPagina({ ...this.pagination, page: 1 })
  }

  /** Pesquisar e trocar de página se comportam igual: limpa a grade e mostra o loading (FXCS-6701). */
  async buscarPagina(pagination: DataTablePagination) {
    this.getConfigUsuarioStore.clearPessoasAgendamento()
    this.loadingPessoas = true
    await this.getConfigUsuarioStore.getAllPessoaAgendamento(pagination)
    this.loadingPessoas = false
  }

  async abrirModalEditarPessoa(id: string) {
    this.pessoaId = id
    const response = await this.getConfigUsuarioStore.getPessoaAgendamentoById(id)
    if (response.success) {
      this.editPessoa = true
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || 'Ocorreu erro ao buscar a pessoa.',
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.pessoaId = ''
  }

  closeSuporteFeedbackModal() {
    this.buscarPagina(this.pagination)
    this.$refs.formPessoa.resetValidation()
    this.$refs.formPessoa.reset()
    this.editPessoa = false
    this.showSuporteFeedbackModal = false
    this.suporteFeedbackModalData = []
  }

  async editarPessoa() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    const response = await this.getConfigUsuarioStore.atualizaPessoaAgendamento()
    if (response.success) {
      EventBus.$emit('clearLoadingRequest')
      this.suporteFeedbackModalData = response.data
      this.showSuporteFeedbackModal = true
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || 'Ocorreu erro ao enviar os dados.',
        icon: 'warning',
        color: '#C62828',
      })
    }
  }

  async mounted() {
    // A store é compartilhada com a tela de Usuários: começa limpa, sem buscar.
    this.getConfigUsuarioStore.setSearchPessoa('')
    this.getConfigUsuarioStore.setTipoBuscaPessoaAgendamento('nome')
    this.getConfigUsuarioStore.clearPagination()
    this.getConfigUsuarioStore.clearPessoasAgendamento()
  }

  beforeDestroy() {
    this.getConfigUsuarioStore.clearPessoasAgendamento()
    this.getConfigUsuarioStore.clearPessoaAgendamento()
  }
}
